import { render, staticRenderFns } from "./BizBusinessinfoBusinessTypeList.vue?vue&type=template&id=bace560c&scoped=true&"
import script from "./BizBusinessinfoBusinessTypeList.vue?vue&type=script&lang=js&"
export * from "./BizBusinessinfoBusinessTypeList.vue?vue&type=script&lang=js&"
import style0 from "./BizBusinessinfoBusinessTypeList.vue?vue&type=style&index=0&id=bace560c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bace560c",
  null
  
)

export default component.exports